import localforage from "localforage";

let authCache = localforage.createInstance({
    driver: localforage.INDEXEDDB,
    name: 'ruuts-mdc',
    version: 1.0,
    storeName: 'authCache',
    description: 'cache for auth0'
})

let appCache = localforage.createInstance({
    driver: localforage.INDEXEDDB,
    name: 'ruuts-mdc',
    version: 1.0,
    storeName: 'appCache',
    description: 'cache for app'
})

export const appStore = {
    get: async function (key) {
        try {
            let value = await appCache.getItem(key);
            return value;
        } catch (e) {
            // Mejorar el logging de errores para identificar problemas
            console.error(`Error al leer de appStore la clave "${key}":`, e);
            // Si es un error crítico (cuota excedida, storage no disponible), loguear más detalles
            if (e.name === 'QuotaExceededError' || e.name === 'DOMException') {
                console.error(`Error crítico de almacenamiento al leer "${key}":`, {
                    name: e.name,
                    message: e.message,
                    stack: e.stack
                });
            }
            // Retornar undefined para mantener compatibilidad con código existente
            // El código que usa appStore debe manejar el caso de undefined
            return undefined;
        }
    },
    set: async function (key, value) {
        try {
            await appCache.setItem(key, value);
        } catch (e) {
            // Mejorar el logging de errores
            console.error(`Error al escribir en appStore la clave "${key}":`, e);
            // Si es un error crítico, loguear más detalles
            if (e.name === 'QuotaExceededError' || e.name === 'DOMException') {
                console.error(`Error crítico de almacenamiento al escribir "${key}":`, {
                    name: e.name,
                    message: e.message,
                    stack: e.stack
                });
                // Para errores críticos, podríamos considerar lanzar la excepción
                // pero por ahora mantenemos compatibilidad
            }
            // No lanzamos la excepción para mantener compatibilidad
            // pero el error queda registrado para debugging
        }
    },
    remove: async function (key) {
        try {
            await appCache.removeItem(key);
        } catch (e) {
            console.error(`Error al eliminar de appStore la clave "${key}":`, e);
            // No lanzamos la excepción para mantener compatibilidad
        }
    }
}

export const authStore = {
    get: async function (key) {
        try {
            let value = await authCache.getItem(key);
            return value;
        } catch (e) {
            console.error(e);
        }

    },
    set: async function (key, value) {
        try {
            await authCache.setItem(key, value);
        } catch (e) {
            console.error(e)
        }

    },
    remove: async function (key) {
        await authCache.removeItem(key);
    }
}